import { render, staticRenderFns } from "./cdgk.vue?vue&type=template&id=4326dc70&scoped=true&"
import script from "./cdgk.vue?vue&type=script&lang=js&"
export * from "./cdgk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4326dc70",
  null
  
)

export default component.exports